import React, { useMemo } from "react";
import KC_UIText from "../typography/KC_UIText/KC_UIText";
import { KC_Weights } from "../ds_commons";
import "./styles.scss";

interface TagPropsI {
  text?: string;
  type:
    | "primary"
    | "upsell"
    | "black"
    | "number-increase"
    | "number-decrease"
    | "primary-inverted";
}
export default function KC_Tag(props: TagPropsI) {
  const className = useMemo(() => {
    const classes = [
      "kc-tag",
      props.type === "primary" && "tag-primary",
      props.type === "upsell" && "tag-upsell",
      props.type === "number-increase" && "tag-number-increase",
      props.type === "black" && "tag-black",
      props.type === "primary-inverted" && "tag-primary-inverted"
    ];

    return classes.filter(Boolean).join(" ");
  }, [props.type]);

  return (
    <div className={className}>
      <KC_UIText weight={KC_Weights.md} text={props.text} />
    </div>
  );
}
